import fileData from '../../../interface/props/table/files';

export type ThumbnailAutomationStatus =
  | 'done'
  | 'in_progress'
  | 'failed'
  | 'not_applicable';

const FALLBACK_REASONS: Record<ThumbnailAutomationStatus, string> = {
  done: 'Thumbnail automation completed',
  in_progress: 'Thumbnail automation in progress',
  failed: 'Thumbnail automation failed',
  not_applicable: 'Thumbnail automation not applicable',
};

export function resolveThumbnailAutomationStatusFromFile(
  document: fileData,
): ThumbnailAutomationStatus {
  if (document.thumbnailAutomationStatus) {
    return document.thumbnailAutomationStatus;
  }

  if (document.subtitleUpdated) {
    return 'done';
  }

  return 'not_applicable';
}

export function resolveThumbnailAutomationReasonFromFile(
  document: fileData,
): string {
  if (document.thumbnailAutomationReason) {
    return document.thumbnailAutomationReason;
  }

  const status = resolveThumbnailAutomationStatusFromFile(document);
  return FALLBACK_REASONS[status];
}
